import React from 'react';
import { useConditionalSearchResultContextSERP } from '../../hooks/lib/useConditionalSearchResultContext';
import { StyledSearchSummaryContainerDiv } from './index.style';
import { useCheckBreakpoint, useWindowSize } from '../../hooks';
import { BREAKPOINT_TABLET } from '../../organisms/SearchResults/lib/application.constants';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import { useConditionalPageContextSERP } from '../../hooks';
import { hardCodedAllLocale } from '../../organisms/SearchResults/index.constant';
import clsx from 'clsx';
import { formatNumberByLocale } from '../../utils/src/utils';
import { useConditionalSearchResultsRenderedDataSERP } from '../../hooks/lib/useConditionalRenderedData';

export const SearchSummaryComponent: React.FC = () => {
  const { searchResult } = useConditionalSearchResultContextSERP();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { jsonContent, isMapViewEnabled }: any = useConditionalSearchResultsRenderedDataSERP(renderedData);
  const { currentLocale, pageVal } = useConditionalPageContextSERP();

  let initialNumber = searchResult?.pageInfo?.currentOffset ?? 0;
  const { width } = useWindowSize();

  if (searchResult?.total) {
    initialNumber = initialNumber + 1;
  }
  // add few extra classes for de domain on basis of this flag, in order to achive some design changes
  const addDeClassOnSortBy = isMapViewEnabled && currentLocale === hardCodedAllLocale.de;

  const hotelCount = searchResult?.total?.toString();
  const isDesktop = useCheckBreakpoint('viewportM');
  return (
    <div className="d-flex">
      {searchResult && (
        <StyledSearchSummaryContainerDiv
          className={clsx(
            width && width > BREAKPOINT_TABLET ? 't-subtitle-l' : 't-label-alt-s',
            ' results-summary',
            isMapViewEnabled ? 'results-summary-container' : '',
            addDeClassOnSortBy ? 'result-summary-de' : ''
          )}
        >
          {pageVal === 'chat' ? (
            <div className="chat-summary-section">
              <div className="summary-content">
                <span className="results-count">
                  {`${
                    searchResult?.edges && searchResult?.edges?.length > 0 ? searchResult?.edges?.length : 0
                  } AI Results`}
                </span>
              </div>
            </div>
          ) : (
            <div className={clsx('search-summary-container', isDesktop ? 't-font-l' : ' t-font-s')}>
              {searchResult?.pageInfo ? (
                <span>
                  {/* {initialNumber}-
                  {(searchResult?.pageInfo?.hasNextPage === true
                    ? searchResult?.pageInfo?.nextOffset
                    : searchResult?.total) ?? 0}{' '}
                  {jsonContent.ofLabel}{' '} */}
                  {`${initialNumber} - ${
                    (searchResult?.pageInfo?.hasNextPage === true
                      ? searchResult?.pageInfo?.nextOffset
                      : searchResult?.total) ?? 0
                  } ${jsonContent.ofLabel} `}
                </span>
              ) : (
                <span>
                  {initialNumber}-{searchResult?.total ?? 0} {jsonContent?.ofLabel}{' '}
                </span>
              )}
              <span className="hotel-content">{`${formatNumberByLocale(hotelCount ?? 0, currentLocale)} ${
                jsonContent?.resultsLabel
              } `}</span>
            </div>
          )}
        </StyledSearchSummaryContainerDiv>
      )}
    </div>
  );
};
